// @ts-nocheck - Material Tailwind component prop warnings
import React from 'react';
import Tooltip from '@/components/atoms/Tooltip';
import { chunk } from 'lodash';
import { copyToClipboard } from '@/utils/copyToClipboard';
import { Cell, PillCell } from '@/components/atoms';
import { ColumnDef } from '@/components/organism/Table';
import { ISmartCoolerProduct } from '@/services/smartCoolerProducts';
import Barcode from 'react-barcode';
import { getDateTime } from '@/utils/dateTime';
import { APP_BG } from '@/constant/theme/colors.constant';
import { APPROVED_PRODUCTS_PROPS } from '../constants';
import brokenImage from '../../../assets/images/No-Image-Available.png';
import { APPROVED_SMART_COOLER_PRODUCTS_TEST_IDS as TID } from '@/constant/testIds/approvedSmartCoolerProducts.testIds';
import { tid } from '@/utils/testId';

export const buildColumns = (
  isCopy: string,
  onCopyClick: (key: string) => void,
): ColumnDef<ISmartCoolerProduct>[] => [
    {
      accessor: 'legacyId',
      header: APPROVED_PRODUCTS_PROPS.COLUMNS.LEGACY_ID,
      render: (item, idx) => (
        <Cell
          testId={tid(TID.COL_LEGACY_ID(`${idx}`))}
          value={item?.legacyId}
          tooltip={item?.legacyId || undefined}
          variant="primary"
          copy={
            item?.legacyId
              ? {
                copyKey: `leg-${item.smartCoolerProductId}`,
                isCopy,
                onCopyClick,
              }
              : undefined
          }
          className="w-[100px]"
        />
      ),
    },
    {
      accessor: 'shortProductName',
      header: APPROVED_PRODUCTS_PROPS.COLUMNS.PRODUCT_NAME,
      render: (item, idx) => (
        <Cell
          testId={tid(TID.COL_NAME(`${idx}`))}
          value={item?.shortProductName}
          tooltip={item?.productName || item?.shortProductName || undefined}
          variant="primary"
          copy={{
            copyKey: `name-${item.smartCoolerProductId}`,
            isCopy,
            onCopyClick,
          }}
          className="w-[160px] font-medium"
        />
      ),
    },
    {
      accessor: 'productImage',
      header: APPROVED_PRODUCTS_PROPS.COLUMNS.PRODUCT_IMAGE,
      noTruncate: true,
      render: (item, idx) => (
        <div className="flex items-center justify-start overflow-visible">
          <img
            src={item?.productImage || brokenImage}
            alt="product"
            className={`relative z-10 w-10 h-10 rounded-lg object-contain border border-gray-200 dark:border-gray-700/60 ${APP_BG.canvas} hover:scale-[2.5] hover:z-50 hover:shadow-xl transition-transform duration-200 cursor-zoom-in`}
            onError={(e) => {
              (e.target as HTMLImageElement).src = brokenImage;
            }}
          />
        </div>
      ),
    },
    {
      accessor: 'deletedOn',
      header: APPROVED_PRODUCTS_PROPS.COLUMNS.ACTIVE,
      render: (item, idx) => (
        <Tooltip
          content={
            item?.deletedOn ? `Deleted: ${getDateTime(item.deletedOn)}` : 'Active'
          }
          placement="right"
        >
          <div>
            <PillCell
              testId={tid(TID.COL_STATUS(`${idx}`))}
              value={item?.deletedOn ? 'Inactive' : 'Active'}
              preset={item?.deletedOn ? 'inactive' : 'active'}
              size="text-[11px]"
              className="border font-semibold cursor-default"
            />
          </div>
        </Tooltip>
      ),
    },
    {
      header: APPROVED_PRODUCTS_PROPS.COLUMNS.TRAINED_BARCODES,
      render: (item, idx) => (
        <div
          className={`flex flex-col ${Array.isArray(item?.barcodes) && item?.barcodes.length > 2
              ? 'max-h-[60px] overflow-y-auto'
              : ''
            }`}
        >
          {Array.isArray(item?.barcodes) && item?.barcodes?.length > 0
            ? chunk(item.barcodes, 2).map(
              (barcodeRow: string[], rowIdx: number) => (
                <div key={rowIdx} className="flex flex-row items-center mb-1">
                  {barcodeRow.map((barcode: string, idx: number) => (
                    <div key={idx} className="flex items-center mr-2">
                      <Tooltip content="Copy" placement="top">
                        <span
                          title={barcode}
                          className="ml-1 cursor-pointer text-xs active:bg-green-100 p-0.5 hover:bg-slate-200 hover:rounded-sm"
                          onClick={() => {
                            copyToClipboard(barcode);
                            onCopyClick(`barcode-${barcode}`);
                          }}
                        >
                          <Barcode testId={tid(TID.EXPANDED_BARCODES(`${idx}`))} value={barcode} height={24} />
                        </span>
                      </Tooltip>
                    </div>
                  ))}
                </div>
              ),
            )
            : ''}
        </div>
      ),
    },
  ];